import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import ProductApi from "../../services/ProductApi";
import FamilyApi from "../../services/FamilyApi";
import { useToast } from "../../context/ToastContext";

// Design System
import Input from "../../components/Input/Input";
import FormCard from "../../components/FormCard/FormCard";

const ProductDetails: React.FC = () => {
  const { t: translateForm } = useTranslation("form");
  const { t: translateMessages } = useTranslation("Messages");
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { displayToast } = useToast();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [partNumber, setPartNumber] = useState("");
  const [isProducible, setIsProducible] = useState<boolean>(true);
  const [familyName, setFamilyName] = useState<string>("");

  useEffect(() => {
    const fetchProduct = async (): Promise<void> => {
      if (!id) return;
      try {
        const productResponse = await ProductApi.GetById(id);
        const product = productResponse;
        setName(product.name || "");
        setDescription(product.description || "");
        setPartNumber(product.partNumber || "");
        setIsProducible(product.isProducible ?? true);
        
        if (product.familyId) {
            const familyResponse = await FamilyApi.GetById(product.familyId);
            setFamilyName(familyResponse.data?.name || "");
        }
      } catch {
        displayToast("error", translateMessages("error"), translateForm("errorLoadingProduct"), false, 3000);
      }
    };
    fetchProduct();
  }, [id, displayToast, translateMessages, translateForm]);

  const handleBack = (): void => navigate("/products");

  return (
    <FormCard
      title={translateForm("detailsProduct")}
      icon="info"
      onSubmit={() => {}}
      onCancel={handleBack}
      cancelButtonLabel={translateForm("Cancel") || "Voltar"}
      numColumns={12}
      disabled
    >
      <div style={{ gridColumn: "span 6" }}>
        <Input
          type="text"
          label={translateForm("Family")}
          value={familyName || "—"}
          disabled
          onChange={() => {}}
        />
      </div>

      <div style={{ gridColumn: "span 6" }}>
        <Input
          type="text"
          label={translateForm("status")}
          value={isProducible ? (translateForm("Ativo") || "Ativo") : (translateForm("Inativo") || "Inativo")}
          disabled
          onChange={() => {}}
        />
      </div>

      <div style={{ gridColumn: "span 6" }}>
        <Input
          type="text"
          label={translateForm("partNumber")}
          value={partNumber || "—"}
          disabled
          onChange={() => {}}
        />
      </div>

      <div style={{ gridColumn: "span 6" }}>
        <Input
          type="text"
          label={translateForm("Name")}
          value={name || "—"}
          disabled
          onChange={() => {}}
        />
      </div>

      <div style={{ gridColumn: "span 12" }}>
        <Input
          type="textArea"
          label={translateForm("description")}
          value={description || "—"}
          rows={3}
          disabled
          onChange={() => {}}
        />
      </div>
    </FormCard>
  );
};

export default ProductDetails;
